import { useEffect, useState } from "react";
import { useAppSelector } from "redux-share/hooks";
import useGetData from "helpers/hooks/useGetData/useGetData";
import { conditions, handleNotActiveText, hasPermissionToRedirect } from "helpers";
import { ConditionName } from "interfaces";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const VideoPlayer = dynamic(() => import("./videoPlayer"));
const NotActive = dynamic(() => import("ui/src/components/player-components/notActive/notActive"));

const LiveAndVodPlayer = () => {

    const [notActiveText, setNotActiveText] = useState<any>(undefined);

    const { params, errorType, isValidAddress } = useAppSelector(({ videoData: { params, errorType, details, isValidAddress, isFetchDetails, isComplexDesktop, isComplexPortrait } }) => ({ params, errorType, details, isValidAddress, isFetchDetails, isComplexDesktop, isComplexPortrait }), shallowEqual);
    
    useGetData();

    useEffect(() => {
        if (!conditions(ConditionName.isValidAddress)) setNotActiveText(handleNotActiveText(errorType))
    }, [isValidAddress, errorType])

    useEffect(() => {
        if (conditions(ConditionName.isGeneral)) hasPermissionToRedirect(params.src!);
    }, [conditions(ConditionName.isGeneral)]);

    return (
        <>
            {
                conditions(ConditionName.isFetchDetails) ?
                    conditions(ConditionName.isValidAddress) ? (
                        <div className={`${!!params.height ? params.height : "pl-max-h-[100dvh]"} ${conditions(ConditionName.backgroundColorInLightMode) ? "pl-bg-white" : "pl-bg-dark-1"} dark:pl-bg-dark-1`}>
                            <VideoPlayer />
                        </div>
                    ) : (
                        <div className={`pl-bg-white ${!!params.height ? params.height : "pl-h-screen" } pl-p-4`}>
                            <NotActive
                                title={notActiveText.title}
                                description={notActiveText.description}
                                type={params.type!}
                            />
                        </div>
                    )
                    :
                    <div className={`${!!params.height ? params.height : "pl-h-screen" } ${!!params.width ? params.width : "pl-h-screen" } pl-bg-black`} />
            }
        </>
    )
}

export default LiveAndVodPlayer;